import React, {useState, useEffect, useRef} from 'react';
import ListNav from '../../components/tabsNav/TabsNav';
import {Row} from 'react-bootstrap';
import AuditTrails from '../../components/AuditTrail/AuditTrails';
import {useHistory, useParams} from 'react-router-dom';
import {useUserContext} from '../../contexts/UserContext';
import {useDepartmentContext} from '../../contexts/DepartmentContext';
import {
    getCurrentRisk,
    getUserInChargeOfDepartmentStakeholder,
    acceptRiskByDepartmentStakeholder,
    requestForUpdate,
    acceptRequestForUpdate,
    closeRisk,
    requestForDeleteApi,
    rejectRequestForDelete, getRiskControl, shouldCloseRisk, showVerifyBtn,
} from '../../services/IncurredEvent/incurredEventApi';
import {deleteRisk, deleteLitigationRisk} from '../../services/deleteRisks';
import PageHeader from './pageHeader/PageHeader';
import MainShowIncurredRisks from '../IncurredRisk/MainShowIncurredRisks';
import Prompt from '../../components/prompt/prompt';
import Toast from '../../components/toast/Toast';
import {t} from 'react-switch-lang';
import TransitionModal from '../../components/preventTransitionprompt/TransitionModal';
import Measures from '../Measures/MainRiskMeasure';
import './edit.scss';
import MainShowPotentialRisks from '../potentialRisk/MainShowPotentialRisks';
import MainShowLitigation from '../litigation/MainShowLitigation';
import {getLitigation} from '../../services/litigationService';
import Comments from '../../components/comments/Comments';
import Swal from 'sweetalert2';
import roles from '../../utils/roles';
import Controls from "../Controls/Controls";

const RiskComponents = (props) => {
  let {id} = useParams();

  const user = useUserContext();
  const department = useDepartmentContext();
  const userAuthorities = user.authorities;
  const [allDepartments, setAllDepartments] = useState([]);

  const userInCharge = userAuthorities.some((r) =>
    r.includes(roles.role_user_in_charge)
  );
  useEffect(() => {
    if (department?.length) {
      setAllDepartments(department?.map(d => d.id));
    }
  }, [department]);
    const getSelectedDepartment = (risk) => department?.find(dep => dep?.id === risk?.departmentSourceId);
    const [activeTab, setActiveTab] = useState('details');
    const [renderIncurred, setRenderIncurred] = useState(false);
    const [renderPotentialRisk, setRenderPotentialRisk] = useState(false);
    const [renderLitigation, setRenderLitigation] = useState(false);
    const [transitionModal, setTransitionModal] = useState(false);
    const departmentStakeholder = useRef();
    const status = useRef();
    const actionCode = useRef();
    const currentTab = useRef();
    const acceptedRisk = useRef();
    const [isModalVerifyOpen, setIsModalVerifyOpen] = useState(false);
    const [defaultData, setDefaultData] = useState();
    const [editAllowed, setEditAllowed] = useState(false);
    const [requestForUpdateBtn, setRequestForUpdateBtn] = useState(false);
    const [acceptRequestForUpdateBtn, setAcceptRequestForUpdateBtn] = useState(false);
    const [verifyAllowed, setVerifyAllowed] = useState(false);
    const [acceptButton, setAcceptButton] = useState(false);
    const [decideButton, setDecideButton] = useState(false);
    const [closeButton, setCloseButton] = useState(false);
    const [deleteAllow, setDeleteAllow] = useState(false);
    const [requestForDelete, setRequestForDelete] = useState(false);
    const [acceptRejectDelete, setAcceptRejectDelete] = useState(false);
    const [disabledFields, setDisabledFields] = useState(true);
    const [loading, setLoading] = useState(true);
    const [riskClosingLoading,setRiskClosingLoading] = useState();
    let history = useHistory();
    const url = props.location.pathname;
    const riskAcceptRequestActionCode = 'risk_accept_request_for_update';

    //measures
    const [allowNewMeasure, setAllowMeasureNew] = useState(false);
    const [responsiblePersonRisk, setResponsiblePersonRisk] = useState();
    const [userInChargeRisk, setUserInchargeRisk] = useState();
    const [courtRiskId, setCourtRiskId] = useState(0);
    const departmentSource = useRef();
    const [allowNewControl, setAllowNewControl] = useState(false);
    let isCourtRisk = url.includes('court-risk');

  const toggleTab = (val) => {
    currentTab.current = val;
    if (val !== 'details' && window.location.pathname.includes('edit')) {
        if(transitionModal === false) {
            setTransitionModal(true);
        }
    } else {
      setActiveTab(val);
    }
    if (window.location.search.includes('tab=measures')) {
      history.push(window.location.pathname);
    }
  };

  const toggleVerifyModal = (e) => {
    e && e.preventDefault();
    setIsModalVerifyOpen(!isModalVerifyOpen);
  };

  const allowRiskEditForResponsiblePerson = (risk) => {
    const selectedDepartment = getSelectedDepartment(risk);
    if (
        (risk?.userInChargeId === user?.id || selectedDepartment?.userInChargeReplacementId === user?.id ) &&
        allDepartments.includes(risk.departmentSourceId) &&
        risk.riskStatusId === 1
    ) {
      setEditAllowed(true);
      setRequestForDelete(true);
    }
  }

  const allowRiskEditAfterAcceptedEditRequest = (risk) => {
    const selectedDepartment = getSelectedDepartment(risk);
    if (
        (user.id === risk.userInChargeId || selectedDepartment?.userInChargeReplacementId === user?.id || user.id === risk.userResponsibleId) &&
        (risk.riskStatusId === 2 || risk.riskStatusId === 3) &&
        risk.riskAudit?.actionCode === 'risk_accept_request_for_update'
    ) {
      //izmjena rizika nakon prihvatanja zahtjeva za izmjenu rizika
      setEditAllowed(true);
      setRequestForDelete(true);
    }
  }

  const showRequestForEditAndDeleteBtn = (risk) => {
    const selectedDepartment = getSelectedDepartment(risk);
    if (
      (risk?.userInChargeId === user?.id || selectedDepartment?.userInChargeReplacementId === user?.id ) &&
        allDepartments.includes(risk.departmentSourceId) &&
        risk.riskStatusId !== 1 &&
        risk.riskStatusId !== 4 &&
        risk.riskAudit?.actionCode !== 'risk_accept_request_for_update'
    ) {
      //prikaz opcije ZAHTJEV ZA IZMJENU
      risk.riskAudit?.actionCode !== "risk_request_for_delete" && setRequestForUpdateBtn(true);
      risk.riskAudit?.actionCode !== "risk_request_for_update" && setRequestForDelete(true);
    }
  }

  const acceptOrRejectEditRequestBtnShowForRiskSector = (risk) => {
    if (
        user.authorities.includes('ROLE_RISK_SECTOR') &&
        risk.riskAudit?.actionCode === 'risk_request_for_update'
    ) {
      // risk sector - opcija za prihvatanje/odbijanje zahtjeva za izmjenu
      setAcceptRequestForUpdateBtn(true);
    }
  }

  const riskSectorDecideBtn = (risk) => {
    if (
        user.authorities.includes('ROLE_RISK_SECTOR') &&
        risk.riskStatusId === 2 &&
        risk.riskAudit?.actionCode === 'risk_rejected_by_department'
    ) {
      // console.log('lice risk sector dugme za odluku');
      setDecideButton(true);
    }
  }

  const responsiblePersonVerificationBtnShow = async (risk) => {
  // &&
  //     risk.riskStatusId === 1 &&
  //stari USLOVI     ['risk_updated', 'risk_created', 'risk_deleted', 'measure_created', 'measure_updated', 'measure_verified', 'risk_all_measures_realised', 'risk_reject_request_for_delete'].includes(risk.riskAudit?.actionCode)

      if (
          user.id === risk.userResponsibleId   ) {
          const {data} = await showVerifyBtn(risk.id);
          if(data) {
              setVerifyAllowed(true);
          }
      }
  }

  const showAddingNewMeasureBtn = (risk) => {
    const selectedDepartment = getSelectedDepartment(risk);
    if (risk?.userInChargeId === user?.id || selectedDepartment?.userInChargeReplacementId === user?.id) {
        if(risk?.delayedVerification && risk.riskStatusId !== 4) {
          setAllowMeasureNew(true);
        }
      else if (risk.riskStatusId === 2 || risk.riskStatusId === 3) {
        //mogucnost dodavanja novih mjera
        setAllowMeasureNew(true);
      }
    }
  }

  const showAddingNewControlBtn = (data) => {
    const selectedDepartment = getSelectedDepartment(data);
    if (data?.userInChargeId === user?.id || selectedDepartment?.userInChargeReplacementId === user?.id) {
      setAllowNewControl(true);
    }
  }

  const riskDeletionBtnShow = (risk) => {
    if (
        user.authorities.includes('ROLE_RISK_SECTOR') &&
        risk.riskStatusId !== 4 &&
        risk.riskAudit?.actionCode !== 'risk_request_for_delete'
    ) {
      //prikaz opcije za brisanje rizika
      setDeleteAllow(true);
    }
  }

  const acceptRejectDeleteRequestBtnsShow = (risk) => {
    if (
        user.authorities.includes('ROLE_RISK_SECTOR') &&
        risk.riskAudit?.actionCode === 'risk_request_for_delete'
    ) {
      //opcije za prihvatanje/odbijanje zahtjeva za brisanje rizika
      setAcceptRejectDelete(true);
    }
  }


    const riskSectorCloseRiskBtnShow = async (risk) => {
        if (
            user.authorities.includes('ROLE_RISK_SECTOR')
            && (risk.riskStatusId === 2 || risk.riskStatusId === 3)
            && risk.riskAudit?.actionCode !== 'risk_request_for_update' &&
            risk.riskAudit?.actionCode !== 'risk_request_for_delete'
        ) {
            const {data} = await shouldCloseRisk(risk.id);
            if(data) {
                //risk sektor - prikaz opcije za zatvaranje rizika
                setCloseButton(true);
            }
        }
    }

  useEffect(() => {
    if (!defaultData || !department?.length) return;

    const risk = isCourtRisk ? defaultData.risk : defaultData;

    allowRiskEditForResponsiblePerson(risk);
    allowRiskEditAfterAcceptedEditRequest(risk);
    showRequestForEditAndDeleteBtn(risk);
    acceptOrRejectEditRequestBtnShowForRiskSector(risk);
    riskSectorDecideBtn(risk);
    riskSectorCloseRiskBtnShow(risk);
    responsiblePersonVerificationBtnShow(risk);
    showAddingNewMeasureBtn(risk);
    showAddingNewControlBtn(isCourtRisk ? defaultData : risk);
    riskDeletionBtnShow(risk);
    acceptRejectDeleteRequestBtnsShow(risk);
  }, [defaultData, department]);
  const setFetchedRisk = (data) => {
    setDefaultData(data);

    if (url.includes('court-risk')) {
      departmentStakeholder.current = data.risk.departmentStakeholderId;
      status.current = data.risk.riskStatusId;
      actionCode.current = data.risk.riskAudit.actionCode;
      departmentSource.current = data.risk.departmentSourceId;
      allowRiskEditForResponsiblePerson(data.risk)

      allowRiskEditAfterAcceptedEditRequest(data.risk)

      showRequestForEditAndDeleteBtn(data.risk)

      acceptOrRejectEditRequestBtnShowForRiskSector(data.risk);
      riskSectorDecideBtn(data.risk)

      riskSectorCloseRiskBtnShow(data.risk)

      responsiblePersonVerificationBtnShow(data.risk)
      //measures
      showAddingNewMeasureBtn(data.risk)
      // controls

      showAddingNewControlBtn(data)

      riskDeletionBtnShow(data.risk)

      acceptRejectDeleteRequestBtnsShow(data.risk);
      setUserInchargeRisk(data.risk.userInChargeId);
      setResponsiblePersonRisk(data.risk.userResponsibleId);
    } else {
      departmentStakeholder.current = data.departmentStakeholderId;
      status.current = data.riskStatusId;
      // if(!data.delayedVerification && data.riskAudit) {
        actionCode.current = data.riskAudit?.actionCode;
      // }
      acceptedRisk.current = data?.acceptedRisk;
      departmentSource.current = data.departmentSourceId;
      allowRiskEditForResponsiblePerson(data)

      allowRiskEditAfterAcceptedEditRequest(data)

      showRequestForEditAndDeleteBtn(data)

      acceptOrRejectEditRequestBtnShowForRiskSector(data)

      riskSectorDecideBtn(data);

      riskSectorCloseRiskBtnShow(data)

      responsiblePersonVerificationBtnShow(data)

      //measures
      showAddingNewMeasureBtn(data)

      // controls
      showAddingNewControlBtn(data)

      riskDeletionBtnShow(data)

      acceptRejectDeleteRequestBtnsShow(data)

      setUserInchargeRisk(data.userInChargeId);
      setResponsiblePersonRisk(data.userResponsibleId);
    }
  };

  const fetchControl = async () => {
    try {
        const {data} = await getRiskControl(id);
    } catch (err) {
      if (err.response?.data.status === 403) {
        history.push('/403');
      }
      if (err.response?.data.status === 404) {
        history.push('/not-found');
      }
      setLoading(false);
    }
  }

    const fetchRisk = async () => {
        try {
            if (isCourtRisk) {
                const {data} = await getLitigation(id);
                setFetchedRisk(data);
                setCourtRiskId(data?.risk.id);
            } else {
                const {data} = await getCurrentRisk(id);
                setFetchedRisk(data);
            }
        } catch (err) {
            if (err.response?.data.status === 403) {
                history.push('/403');
            }
            if (err.response?.data.status === 404) {
                history.push('/not-found');
            }
            setLoading(false);
        }
    };

    const fetchUserInChargeDepartmentStakeholder = async () => {
        try {
            const {data} = await getUserInChargeOfDepartmentStakeholder(departmentStakeholder.current);
            if ((user?.id === data?.userInChargeReplacementId || user?.id === data?.userInChargeId) && status.current === 2 && acceptedRisk.current === null) {
                //prihvatanje/odbijanje rizika od strane zaduzenog lica sektora kome se salje rizik
                setAcceptButton(true);
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    };

    const fetchUserReplacement = async () => {
        try {
            const {data} = await getUserInChargeOfDepartmentStakeholder(departmentSource.current);
            if (user.id === data.userInChargeReplacementId || user.id === data.userInChargeId) {
                if (status.current === 2 || status.current === 3) {
                    //mogucnost dodavanja novih mjera - ZAMJENA ZADUZENOG LICA
                    setAllowMeasureNew(true);
                }
                if (actionCode.current === riskAcceptRequestActionCode) {
                    setEditAllowed(true);
                    setRequestForDelete(true)
                }
            }
            setLoading(false);
        } catch (e) {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (url.includes('potential-risk')) {
            if (id !== undefined) {
                const validId = RegExp(/^[0-9]*$/);
                if (validId.test(id)) {
                    fetchControl()
                } else {
                    window.location = '/not-found';
                }
            }
        }
        if (url.includes('incurred-risk')) {
            if (id !== undefined) {
                const validId = RegExp(/^[0-9]*$/);
                if (validId.test(id)) {
                    fetchRisk().then((response) => {
                        fetchUserInChargeDepartmentStakeholder().then((response) => {
                            fetchUserReplacement();
                        });
                    });
                    setRenderIncurred(true);
                } else {
                    window.location = '/not-found';
                }
            }
        }
        if (url.includes('potential-risk')) {
            fetchRisk().then(() => {
                fetchUserInChargeDepartmentStakeholder().then((response) => {
                    fetchUserReplacement();
                });
            });
            setRenderPotentialRisk(true);
        }
        if (isCourtRisk) {
            fetchRisk().then(() => {
                fetchUserInChargeDepartmentStakeholder().then((response) => {
                    fetchUserReplacement();
                });
            });
            setRenderLitigation(true);
        }
        const queryString = require('query-string');
        const parsed = queryString.parse(window.location.search);
        if (parsed.tab === 'measures') {
            setActiveTab('measures');
        }
    }, []);

    const onEdit = (e) => {
        e.preventDefault();
        window.location = window.location.href + '/edit';
    };

    const onCloseRisk = async () => {
        try {
            setRiskClosingLoading(true);
            const response = await closeRisk(isCourtRisk ? courtRiskId : id);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('title.closedRisk'), icon: 'success',
                });
            }
            await window.location.reload();
            setRiskClosingLoading(false);
        } catch (err) {
        }
    };
    const onRequestForUpdate = async () => {
        try {
            const response = await requestForUpdate(isCourtRisk ? courtRiskId : id);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('title.requestForUpdate'), icon: 'success',
                });
              window.location.reload()
            }
        } catch (err) {
        }
    };
    const onAccept = async () => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('title.acceptRisk'),
                text: t('question.acceptRisk'),
                confirmButtonText: t('common.accept').toUpperCase(),
                cancelButtonText: t('common.cancel').toUpperCase(),
                preConfirm: async () => {
                    try {
                        const response = await acceptRiskByDepartmentStakeholder(isCourtRisk ? courtRiskId : id, true);
                        if (response.status === 200) {
                            await Toast.fire({
                                title: t('title.acceptRiskByDepartmentStakeholder'), icon: 'success',
                            });
                            resolve(response);
                        } else {
                            reject(response);
                        }
                      await window.location.reload();
                    } catch (err) {
                    }
                },
            });
        });
    };

    const onReject = async () => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('title.acceptRisk'),
                text: t('question.rejectRisk'),
                confirmButtonText: t('common.refuse').toUpperCase(),
                cancelButtonText: t('common.cancel').toUpperCase(),
                preConfirm: async () => {
                    try {
                        const response = await acceptRiskByDepartmentStakeholder(isCourtRisk ? courtRiskId : id, false);
                        if (response.status === 200) {
                            await Toast.fire({
                                title: t('title.rejectRiskByDepartmentStakeholder'), icon: 'success',
                            });
                            resolve(response);
                        } else {
                            reject(response);
                        }
                      await window.location.reload();
                    } catch (err) {
                    }
                },
            });
        });
    };

    const onAcceptDecide = async () => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('title.riskAffiliation'),
                text: t('question.riskAffiliation'),
                confirmButtonText: t('common.confirm').toUpperCase(),
                cancelButtonText: t('common.cancel').toUpperCase(),
                preConfirm: async () => {
                    try {
                        const response = await acceptRiskByDepartmentStakeholder(isCourtRisk ? courtRiskId : id, true);
                        if (response.status === 200) {
                            await Toast.fire({
                                title: t('title.decideRiskSectorBelongs'), icon: 'success',
                            });
                            resolve(response);
                            await window.location.reload();
                        } else {
                            reject(response);
                        }
                    } catch (err) {
                    }
                },
            });
        });
    };

    const onRejectDecide = async () => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('title.riskAffiliation'),
                text: t('question.riskAffiliationNo'),
                confirmButtonText: t('common.confirm').toUpperCase(),
                cancelButtonText: t('common.cancel').toUpperCase(),
                preConfirm: async () => {
                    try {
                        const response = await acceptRiskByDepartmentStakeholder(isCourtRisk ? courtRiskId : id, false);
                        if (response.status === 200) {
                            await Toast.fire({
                                title: t('title.decideRiskSectorNotBelongs'), icon: 'success',
                            });
                            resolve(response);
                            await window.location.reload();
                        } else {
                            reject(response);
                        }
                    } catch (err) {
                    }
                },
            });
        });
    };
    const onAcceptRequestForUpdate = async () => {
        try {
            const response = await acceptRequestForUpdate(isCourtRisk ? courtRiskId : id, true);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('title.acceptRequestForUpdate'), icon: 'success',
                });
            }
            await window.location.reload();
        } catch (err) {
        }
    };

    const onRejectRequestForUpdate = async () => {
        try {
            const response = await acceptRequestForUpdate(isCourtRisk ? courtRiskId : id, false);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('title.rejectRequestForUpdate'), icon: 'success',
                });
            }
            await window.location.reload();
        } catch (err) {
        }
    };

    const onDelete = async (record) => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('title.deleteRisk'),
                text: t('question.deleteRisk'),
                confirmButtonText: t('common.confirm'),
                cancelButtonText: t('common.cancel'),
                preConfirm: async () => {
                    try {
                        const response = isCourtRisk ? await deleteLitigationRisk(courtRiskId) : await deleteRisk(id);
                        if (response.status === 204) {
                            await Toast.fire({
                                title: t('message.deleteSuccess2', {entity: t('common.risk')}), icon: 'success',
                            });
                            resolve(response);
                            await history.push('/risks');
                        } else {
                            reject(response);
                        }
                    } catch (err) {
                        Swal.fire({
                            text: t('Pages.messages.deleteError'), icon: 'error',
                        });
                    }
                },
            });
        });
    };

    const onAcceptRequestForDelete = async () => {
        return new Promise((resolve, reject) => {
            Prompt.fire({
                title: t('title.deleteRisk'),
                text: t('question.deleteRisk'),
                confirmButtonText: t('common.confirm'),
                cancelButtonText: t('common.cancel'),
                preConfirm: async () => {
                    try {
                        const response = isCourtRisk ? await deleteLitigationRisk(courtRiskId) : await deleteRisk(id);
                        if (response.status === 204) {
                            await Toast.fire({
                                title: t('message.deleteSuccess2', {entity: t('common.risk')}), icon: 'success',
                            });
                            resolve(response);
                            await history.push('/risks');
                        } else {
                            reject(response);
                        }
                    } catch (err) {
                        Swal.fire({
                            text: t('Pages.messages.deleteError'), icon: 'error',
                        });
                    }
                },
            }).then((result) => {
                if(!result.isConfirmed) {
                    resolve();
                }
            });
        });
    };

    const onRequestForDelete = async () => {
        try {
            const response = await requestForDeleteApi(isCourtRisk ? courtRiskId : id);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('title.requestForDelete'), icon: 'success',
                });
                window.location.reload()
            }
        } catch (err) {
        }
    };

    const onRejectForDelete = async () => {
        try {
            const response = await rejectRequestForDelete(isCourtRisk ? courtRiskId : id);
            if (response.status === 200) {
                await Toast.fire({
                    title: t('title.requestForDelete'), icon: 'success',
                });
            }
            await window.location.reload();
        } catch (err) {
        }
    };

    return (<div
        className="h-100 edit-clients-page edit-employee position-relative"
        style={{minHeight: '100vh'}}
    >
      <PageHeader
        id={id}
        title={url}
        allowEdit={editAllowed}
        allowVerify={verifyAllowed}
        requestForUpdateBtn={requestForUpdateBtn}
        acceptRequestForUpdateBtn={acceptRequestForUpdateBtn}
        closeButton={closeButton}
        decideButton={decideButton}
        onAcceptDecide={(e) => onAcceptDecide(e)}
        onRejectDecide={(e) => onRejectDecide(e)}
        onAcceptRequestForUpdate={(e) => onAcceptRequestForUpdate(e)}
        onRejectRequestForUpdate={(e) => onRejectRequestForUpdate(e)}
        onRequestForUpdate={() => onRequestForUpdate()}
        onEdit={(e) => onEdit(e)}
        onVerify={(e) => toggleVerifyModal(e)}
        acceptButton={acceptButton}
        onAccept={(e) => onAccept(e)}
        onReject={(e) => onReject(e)}
        riskClosingLoading={riskClosingLoading}
        onCloseRisk={(e) => onCloseRisk(e)}
        disabled={disabledFields}
        correctTab={activeTab}
        url={url}
        deleteAllow={deleteAllow}
        onDeleteRisk={(e) => onDelete(e)}
        requestForDelete={requestForDelete}
        onRequestForDelete={(e) => onRequestForDelete(e)}
        acceptRejectDelete={acceptRejectDelete}
        onAcceptRequestForDelete={(e) => onAcceptRequestForDelete(e)}
        onRejectForDelete={(e) => onRejectForDelete(e)}
        defaultData={defaultData}
      />
      <ListNav
        items={[
          {name: t('tabsNav.details'), target: 'details'},
          url.includes('potential-risk') && {name: t('controls.controls'), target: 'control'},
          {name: t('tabsNav.measures'), target: 'measures'},
          {name: t('tabsNav.comments'), target: 'comments'},
          {name: t('tabsNav.auditTrail'), target: 'auditTrail'},
        ]}
        textProperty="name"
        itemValue="target"
        selectedItem={activeTab}
        onItemSelect={toggleTab}
        classes="tabs-nav ml-0"
      />
      <Row className="px-3">
        {activeTab === 'details' &&
          !loading &&
          (renderPotentialRisk ? (
            <>
              <TransitionModal
                open={transitionModal}
                toggleModal={() => setTransitionModal(!transitionModal)}
                onCancel={() => setTransitionModal(false)}
                onOk={() => {
                    window.history.pushState({}, '', `/potential-risk/${id}`);
                  setActiveTab(currentTab.current);
                  setTransitionModal(false);
                }}
              />
              <MainShowPotentialRisks
                defaultData={defaultData}
                isModalVerifyOpen={isModalVerifyOpen}
                setIsModalVerifyOpen={(e) => setIsModalVerifyOpen(e)}
              />
            </>
          ) : (
            <div />
          ))}
        {activeTab === 'details' &&
          !loading &&
          (renderLitigation ? (
            <>
              <TransitionModal
                open={transitionModal}
                toggleModal={() => setTransitionModal(!transitionModal)}
                onCancel={() => setTransitionModal(false)}
                onOk={() => {
                    window.history.pushState({}, '', `/court-risk/${id}`);
                  setActiveTab(currentTab.current);
                  setTransitionModal(false);
                }}
              />
              <MainShowLitigation
                defaultData={defaultData}
                isModalVerifyOpen={isModalVerifyOpen}
                setIsModalVerifyOpen={(e) => setIsModalVerifyOpen(e)}
              />
            </>
          ) : (
            <div />
          ))}
        {activeTab === 'details' &&
          !loading &&
          (renderIncurred ? (
            <>
              <TransitionModal
                open={transitionModal}
                toggleModal={() => setTransitionModal(!transitionModal)}
                onCancel={() => setTransitionModal(false)}
                onOk={() => {
                    window.history.pushState({}, '', `/incurred-risk/${id}`);
                  setActiveTab(currentTab.current);
                  setTransitionModal(false);
                }}
              />
              <MainShowIncurredRisks
                defaultData={defaultData}
                isModalVerifyOpen={isModalVerifyOpen}
                setIsModalVerifyOpen={(e) => setIsModalVerifyOpen(e)}
              />
            </>
          ) : (
            <div />
          ))}
        {activeTab === 'measures' && (
          <Measures
            defaultData={defaultData}
            allowNewMeasure={allowNewMeasure}
            responsiblePersonRisk={responsiblePersonRisk}
            userInChargeRisk={userInChargeRisk}
            id={
              url.includes('court-risk')
                ? defaultData?.risk.id
                  ? defaultData?.risk.id
                  : id
                : id
            }
            riskStatusId={isCourtRisk ? defaultData?.risk?.riskStatusId : defaultData?.riskStatusId}
            estimatedGrossLost={
              url.includes('incurred-risk')
                ? defaultData?.estimatedGrossLost
                : url.includes('court-risk')
                ? defaultData?.risk.estimatedGrossLost
                : 'no-data'
            }
            tab={currentTab.current}
          />
        )}

            {activeTab === 'control' && (<Controls
                defaultData={defaultData}
                allowNewControl={allowNewControl}
                responsiblePersonRisk={responsiblePersonRisk}
                userInChargeRisk={userInChargeRisk}
                id={isCourtRisk ? defaultData?.risk.id || id : id}
                tab={currentTab.current}
            />
        )}

            {activeTab === 'comments' && (<Comments
                defaultData={defaultData}
                id={isCourtRisk ? defaultData?.risk.id : id}
            />)}
            {activeTab === 'auditTrail' && (<AuditTrails
                id={isCourtRisk ? defaultData?.risk.id : id}
                activeRisk={defaultData}
            />)}
        </Row>
    </div>);
};

export default RiskComponents;
